var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "myModalRef",
          attrs: {
            "ok-only": true,
            title: "Detalhes do Cupom",
            size: "lg",
            "hide-header": true
          },
          on: { hidden: _vm.hide }
        },
        [
          _vm.coupon
            ? _c("div", { staticClass: "coupon_code_section" }, [
                _c("div", { staticClass: "coupon_logo" }, [
                  _vm.store
                    ? _c("img", {
                        attrs: { src: _vm.store.image, alt: "Carregando..." }
                      })
                    : _c("img", {
                        attrs: { src: _vm.coupon.image, alt: "Carregando..." }
                      })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "coupon_description" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.coupon.description))])
                ]),
                _vm._v(" "),
                _vm.coupon.trackingLink
                  ? _c(
                      "div",
                      { staticClass: "coupon_form" },
                      [
                        this.$route.params.slug
                          ? _c("p", [
                              _c("span", [
                                _vm._v(
                                  "Você estará ajudando o projeto selecionado:"
                                )
                              ])
                            ])
                          : _c("p", [
                              _c("span", [
                                _vm._v(
                                  "Selecione um projeto abaixo para ajudar"
                                )
                              ])
                            ]),
                        _vm._v(" "),
                        this.$route.params.slug
                          ? _c(
                              "b-form-select",
                              {
                                staticClass: "mb-3",
                                attrs: { disabled: "" },
                                on: { input: _vm.onChangeProject },
                                model: {
                                  value: _vm.ProjectSlug,
                                  callback: function($$v) {
                                    _vm.ProjectSlug = $$v
                                  },
                                  expression: "ProjectSlug"
                                }
                              },
                              _vm._l(_vm.projects, function(p, i) {
                                return _c(
                                  "option",
                                  { key: i, domProps: { value: p.slug } },
                                  [_vm._v(_vm._s(p.Info.title))]
                                )
                              }),
                              0
                            )
                          : _c(
                              "b-form-select",
                              {
                                staticClass: "mb-3",
                                on: { input: _vm.onChangeProject },
                                model: {
                                  value: _vm.ProjectSlug,
                                  callback: function($$v) {
                                    _vm.ProjectSlug = $$v
                                  },
                                  expression: "ProjectSlug"
                                }
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v("Selecione um projeto...")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: "all" } }, [
                                  _vm._v("Ajudar todos os Projetos")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.projects, function(p, i) {
                                  return _c(
                                    "option",
                                    { key: i, domProps: { value: p.slug } },
                                    [_vm._v(_vm._s(p.Info.title))]
                                  )
                                })
                              ],
                              2
                            ),
                        _vm._v(" "),
                        _vm.ProjectSlug && !_vm.loading
                          ? _c(
                              "div",
                              { staticClass: "clearfix add_coupon_code" },
                              [
                                _vm.coupon.trackingLink
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "button tracking",
                                        attrs: {
                                          target: "_blank",
                                          href: _vm.url
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            Acessar Desconto!\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loading
                          ? _c(
                              "div",
                              {
                                staticClass: "clearfix add_coupon_code loading"
                              },
                              [
                                _vm._v(
                                  "\n          Aguarde, carregando seu link...\n        "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ProjectSlug && _vm.coupon.trackingLink
                          ? _c("h6", [
                              _vm._v(
                                "Clique no botão acima para ativar o seu desconto."
                              ),
                              _c("br"),
                              _vm._v(
                                "Ao efetuar a compra, o projeto selecionado será beneficiado."
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  : _c("div", { staticClass: "coupon_form" }, [
                      _c("p", [
                        _c("span", [
                          _vm._v("Ajude todos os projetos da Click2Giv")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix add_coupon_code" }, [
                        _c("input", {
                          staticStyle: {
                            position: "absolute",
                            "z-index": "-9",
                            left: "0"
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.coupon.code }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control unselectable",
                          attrs: {
                            type: "text",
                            id: "abcd",
                            name: "",
                            readonly: ""
                          },
                          domProps: { value: _vm.coupon.code },
                          on: {
                            click: function($event) {
                              return _vm.copyToClipboard()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "button",
                            attrs: { target: "_blank" },
                            on: {
                              click: function($event) {
                                return _vm.copyToClipboard()
                              }
                            }
                          },
                          [_vm._v("\n              Copiar\n            ")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.coupon.trackingLink
                        ? _c("h6", [
                            _vm._v(
                              'Clique no código ou em "Acessar" para copiar o cupom.'
                            ),
                            _c("br"),
                            _vm._v(
                              "Adicione o código no carrinho de compras no site da loja se necessário."
                            )
                          ])
                        : _c("h6", [
                            _vm._v(
                              "Copie o cupom, e adicione o código no carrinho de compras no site da loja."
                            )
                          ])
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.coupon
            ? _c("div", { staticClass: "coupon_footer" }, [
                _c("div", { staticClass: "social_link_view" }, [
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "at",
                          attrs: {
                            href:
                              "mailto:?subject=DescontosDoBem&body=" +
                              _vm.coupon.trackingLink
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "at"], size: "lg" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "twi",
                          attrs: {
                            href:
                              "https://twitter.com/share?text=DescontosDoBem&url=" +
                              _vm.coupon.trackingLink,
                            target: "_blank"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fab", "twitter"], size: "lg" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "face",
                          attrs: {
                            href:
                              "https://facebook.com/sharer/sharer.php?u=" +
                              _vm.coupon.trackingLink,
                            target: "_blank"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fab", "facebook"], size: "lg" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          staticClass: "whats",
                          attrs: {
                            href:
                              "whatsapp://send?text=" + _vm.coupon.trackingLink,
                            target: "_blank"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fab", "whatsapp"], size: "lg" }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("h5", [_vm._v("Compartilhe e ajude ainda mais")])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14eae47f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14eae47f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/descontosdobem/CouponModal.vue
// module id = null
// module chunks = 